import { FormatContentToFeedsUseCase } from "@mais-retorno-front/core-business/useCases/feeds/format-content-to-feeds.usecase";

export const makeFormatContentToFeeds = () => {
  return new FormatContentToFeedsUseCase();
};
